import {Helmet} from '@dr.pogodin/react-helmet';
import {showNotification} from 'platform/components';

import {usePutManufacturersRefreshMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';
import {DmsDataGrid, handleApiError, refreshDmsDatagrid} from '@dms/shared';

export function WarehousesManufacturers() {
  const [refreshManufacturers] = usePutManufacturersRefreshMutation();

  const handleRefresh = () => {
    refreshManufacturers()
      .unwrap()
      .then(() => {
        showNotification.success(i18n.t('general.notifications.dataSuccessfullyRefreshed'));
        refreshDmsDatagrid('warehouse-manufacturer');
      })
      .catch(handleApiError);
  };

  const header: SettingsTemplateHeader = {
    title: i18n.t('entity.warehouse.labels.manufacturers'),
    actions: [
      {
        type: 'button',
        title: i18n.t('general.actions.refresh'),
        onClick: handleRefresh,
      },
    ],
  };

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.manufacturers')} />
      <SettingsTemplate
        data-testid={testIds.settings.warehousesManufacturers('template')}
        header={header}
      >
        <DmsDataGrid
          gridCode="warehouse-manufacturer"
          emptyState={{
            headline: i18n.t('page.warehouseDetail.labels.emptyManufacturers'),
          }}
          data-testid={testIds.settings.warehousesManufacturers('warehouse-manufacturer')}
        />
      </SettingsTemplate>
    </>
  );
}
